import { accountTypes, InputType } from 'config'

const fieldTypeOption: Record<string, any> = {
  // text: 'Text',
  check: 'Yes/No',
  // toggle: 'Toggle',
  // select: 'Select',
  // map: 'Map',
}

export const defaultChecklistInputs = (): Record<string, InputType> => {
  return {
    inputType: {
      inputType: 'select',
      options: fieldTypeOption,
      title: 'Field Type',
      hasDefaultOption: true,
      span: 1,
    },
    title: {
      inputType: 'text',
      title: 'Field Title',
      span: 2,
    },
    checkIneligible: {
      inputType: 'checkbox',
      title: 'Check Ineligible',
    },
    responsibility: {
      title: 'Responsibility',
      inputType: 'Select',
      options: accountTypes,
      value: '',
      error: '',
      key: 'responsibility',
      required: true,
      hasDefaultOption: true,
      sort: true,
    },
  }
}
